import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Formik } from 'formik';
import { get, find } from 'lodash';
import queryString from 'query-string';
import SignupStepOne from './../SignupForm/SignupStepOne.js';
import SignupStepTwo from '../SignupForm/SignupStepTwo.js';
import SignupStepThree from '../SignupForm/SignupStepThree.js';
import SignupStepFour from '../SignupForm/SignupStepFour.js';
import { signUpValidation } from './../../../utils/validation';
import countryList from 'react-select-country-list';

import config from './../../../config/config.json';
const { appHost } = config[process.env.REACT_APP_DIST_ENV];

const SignupFormWrapper = ({ register, setThankYou }) => {
  const [step, setStep] = useState(1);
  const query = queryString.parse(window.location.search);
  // const noDemo = get(query, ['nodemo'], '');
  const coupon = get(query, ['coupon'], '');
  const country = find(countryList().getData(), { value: 'US' });
  const nextStep = () => setStep(step + 1);
  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        email: '',
        // phone: '',
        password: '',
        businessType: '',
        passwordConfirm: '',
        country,
        landingPages: '10',
        problem: '',
        businessVatNumber: '',
        coupon,
      }}
      validationSchema={signUpValidation}
      onSubmit={(values, actions) => {
        register(values)
          .then(({ data = {} }) => {
            // if (parseInt(values.landingPages) > 50 && !noDemo)
            //   setThankYou(`&name=${data.user.email}&email=${data.user.email}`);
            // else
            window.location.replace(
              `${appHost}/login/?userid=${data.user._id}&username=${data.user.username}&token=${data.jwt}`,
            );
          })
          .catch(error => {
            setStep(1);
            actions.setFieldError(
              'email',
              get(
                error,
                'response.data.message[0].messages[0].message',
                'Email is already taken',
              ),
            );
            actions.setSubmitting(false);
          });
      }}
    >
      {props => {
        const { dirty, errors } = props;

        const isEmail = errors.hasOwnProperty('email');
        const isBusinessType = errors.hasOwnProperty('businessType');
        const disabled = !dirty || isEmail || isBusinessType;
        return (
          <Fragment>
            {step === 1 && (
              <SignupStepOne
                nextStep={nextStep}
                disabled={disabled}
                {...props}
              />
            )}
            {step === 2 && (
              <SignupStepTwo
                nextStep={nextStep}
                disabled={disabled}
                {...props}
              />
            )}
            {step === 3 && (
              <SignupStepThree
                nextStep={nextStep}
                disabled={disabled}
                {...props}
              />
            )}
            {step === 4 && <SignupStepFour {...props} />}
          </Fragment>
        );
      }}
    </Formik>
  );
};

export default SignupFormWrapper;

SignupFormWrapper.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  step: PropTypes.number,
  nextStep: PropTypes.func,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  register: PropTypes.func.isRequired,
  setThankYou: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/components/SignupFormWrapper/SignupFormWrapper.js